import React from 'react';
import PhotoUploader from '../PhotoUploader';

interface UploadedPhoto {
  key: string;
  url: string;
  label?: string;
}

interface FormPhotoUploadProps {
  submissionId: string;
  onChange: (photos: UploadedPhoto[]) => void;
  value?: UploadedPhoto[];
  maxPhotos?: number;
  label?: string;
}

/**
 * Thin wrapper around the existing PhotoUploader for use in form submissions.
 * Uses entityType='safety' and the submissionId as entityId so uploads
 * land under a predictable R2 prefix.
 */
export default function FormPhotoUpload({
  submissionId,
  onChange,
  value = [],
  maxPhotos = 6,
  label = 'Photos',
}: FormPhotoUploadProps) {
  return (
    <PhotoUploader
      entityType="safety"
      entityId={submissionId}
      onChange={onChange}
      value={value}
      maxPhotos={maxPhotos}
      label={label}
    />
  );
}
